<template>
  <div>
    <!--    <steps-order-->
    <!--      :step=5-->
    <!--    ></steps-order>-->

    <section class="invoice">
      <!-- title row -->
      <div class="row">
        <div class="col-xs-12">
          <h2 class="page-header">
            <i class="fa fa-shopping-cart"></i>
            Commande échouée
          </h2>
        </div>
      </div>
      <!-- Table row -->
      <div class="row choixModePayement">
        <div class="col-md-12">
          <div class="info-box">
            <span class="info-box-icon bg-red"><i
              class="fa fa-remove"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">Malheureusement, votre commande n'a pas pu être validée.</span>
              <!--              <span class="info-box-number">Dés réception de votre payement, votre commande sera traitée dans les plus brefs délais</span>-->
              <span
                class="info-box-more">Le paiement de votre commande n´a pas pu être finalisé avec le moyen choisi. </span>
              <div style="margin-top: 10px;">
                <div class="btn btn-primary " @click.prevent="goToPayementScreen()">Réessayer le paiement</div>
              </div>

            </div>
          </div>
        </div>
        <!--        <div class="col-md-6">-->
        <!--          <div class="info-box">-->
        <!--            <span class="info-box-icon bg-gray-light"><i class="fa fa-credit-card"></i></span>-->
        <!--            <div class="info-box-content">-->
        <!--              <span class="info-box-text">Payement en ligne</span>-->
        <!--              <span class="info-box-number">Payer via la plateforme sécurisée</span>-->
        <!--              <a @click.prevent="choixModePayement('online')" class="info-box-number" style="margin-top: 20px;font-weight: normal;">Choisir ce moyen de payement</a>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <div class="row no-print">
        <!--<div class="col-xs-12">-->
        <!--<router-link :to="{name: 'Confirm'}">-->
        <!--<a type="button" class="btn btn-primary pull-right">-->
        <!--<i class="fa fa-credit-card"></i>-->
        <!--Confirmer ce moyen de payement-->
        <!--</a>-->
        <!--</router-link>-->
        <!--</div>-->
        <div class="col-xs-12">
          <small class="">Une question? Une remarque? <br>Contactez-nous par téléphone au <strong>02/347.34.77</strong>
            ou par mail à l'adresse <strong>
              <a href="mailto:'secretariat@abft.be'">secretariat@abft.be</a></strong></small>
        </div>
        <div class="col-xs-12">
          <button @click.prevent="goToCart()" type="button" style="margin-top: 25px;"
                  class="btn btn-default pull-right ">
            <!--            <i class="fa fa-credit-card"></i>-->
            Retour au panier
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import {mapGetters, mapActions} from 'vuex'
import stepsOrder from '../stepsOrder'
let _ = require('lodash')

export default {
  data() {
    return {}
  },
  methods: {
    ...mapActions({
      setOrderPayed: 'setOrderPayed',
      setStepOrder:'setStepOrder'
    }),
    goToPayementScreen: function () {
      this.$router.push({
        name: 'ChoixPayement',
      })
    },
    goToCart: function () {
      this.setStepOrder({step: 'step1', value: false})
      this.setStepOrder({step: 'step2', value: false})
      this.setStepOrder({step: 'step3', value: false})
      this.setStepOrder({step: 'step4', value: false})
      this.$router.push({name: 'Panier'});
    },

  },
  components: {
    stepsOrder
  },
  computed: {
    ...mapGetters({
      getCart: 'getCart'
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Order/FailingOrder.vue